var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 131,
    height: 131,
    fill: "none",
    viewBox: "0 0 131 131",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M1.779 1.875c-4.09 4.52-3.21 5.715 25.595 34.77 14.988 15.116 27.418 27.97 27.623 28.563.206.593-12.094 13.551-27.332 28.797C3 118.681-.005 122.032.292 124.536c.189 1.6 1.463 3.653 2.957 4.763 2.212 1.644 2.999 1.761 5 .744 1.306-.665 14.62-13.403 29.587-28.307 14.966-14.905 27.422-26.895 27.68-26.645.258.25 12.313 12.184 26.788 26.519 14.476 14.335 27.497 26.835 28.935 27.777 4.683 3.066 9.975-1.015 8.724-6.729-.187-.85-12.281-13.598-26.876-28.329C88.491 79.6 76.173 66.937 75.714 66.193c-.601-.973 6.943-9.15 26.787-29.042 24.089-24.145 27.623-28.078 27.623-30.74 0-3.563-2.651-6.365-6.022-6.365-1.76 0-9.571 7.178-30.574 28.096l-28.21 28.096L36.97 28.16C7.164-1.366 5.7-2.458 1.779 1.875Z",
    clipRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.d134a1b1d316c1e11dd30d6b25551b28.svg";
export { ForwardRef as ReactComponent };